import React, { useContext } from 'react';
import CartContext from 'js/context/CartContext';

/* Utilities */
import { currency, trans } from 'js/utilities';
import { getCloudImageUrl } from 'js/utilities/image';
import { isProductCompatibleWithStoredVehicle } from 'js/utilities/vehicleCompatibility';

/* Atoms */
import { Icon } from 'js/components/atoms';

/* Symbols */
import crossIcon from 'symbols/cross.svg';

export default function CardCart({ product }) {
    const { handleRemoveFromCart } = useContext(CartContext);
    const isCompatible = isProductCompatibleWithStoredVehicle(product);

    return (
        <div className="card card--bordered card--cart">
            <div className="card-body">
                <button className="card__button--remove close" title={trans('sulu.modal.header.close.title')} aria-label={trans('sulu.modal.header.close.title')} onClick={() => handleRemoveFromCart(product.id)}>
                    <Icon url={crossIcon} size={24} theme="white" />
                </button>

                <div className="d-flex flex-row justify-content-between gap-4">
                    <div>
                        {product?.name &&
                            <h6 className="card__title mb-0">{product.name}</h6>
                        }
                        {product?.productNumber && (
                            <p className="text--16 text-muted mb-2">{product.productNumber}</p>
                        )}

                        <div className="price line-height-1">
                            <p className="mb-0 font-weight-extra-bold">{currency(product?.price)}</p>
                            <span className="text--12 text-muted--80">{trans('sulu.content_block.product_overview.card.price.price_desc')}</span>
                        </div>
                    </div>
                    {product?.image && (
                        <div className="card__image">
                            <img
                                src={getCloudImageUrl(product.image, { width: 180, height: 120 })}
                                alt={product.name || "product afbeelding"}
                                className="img-fluid rounded"
                                width="180"
                                height="120"
                            />
                        </div>
                    )}
                </div>

                {false === isCompatible.compatible && (
                    <div className="d-flex mt-4 justify-content-end">
                        <span className="alert alert-primary text--12 py-1 px-2">{trans('app.product.incompatible.reason.' + isCompatible.reason)}</span>
                    </div>
                )}

            </div>
        </div>
    );
}
